const phoneValidator = (phoneNumber) => {
  if (!phoneNumber || !phoneNumber.length) {
    return true;
  }
  return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phoneNumber);
};
export {
  phoneValidator
};
//# sourceMappingURL=phone.es.js.map
